import { Team } from "@velaro/velaro-component-lib";
import type { TeamRoutingTier, UserTierAssignment } from "./TeamTierPanel";

export interface NewTeam extends Omit<Team, "id"> {
  sharedScheduleId?: number | null;
  enableVideoChat?: boolean;
  routingTiers?: TeamRoutingTier[];
  userTierAssignments?: UserTierAssignment[];
  /** ISO 639-1 code. When set, all outbound agent messages are translated to this language for the visitor. Null = use visitor's auto-detected language. */
  defaultVisitorLanguage?: string | null;
}

export const defaultTeamModel: NewTeam = {
  name: "",
  userIds: [],
  routingAction: "AutoRoute",
  unassignAction: "Reroute",
  routingType: "roundRobin",
  isDefault: false,
  inactiveAgentAction: "UnassignAgent",
  unassignWarningTime: 0,
  unassignTime: 0,
  autoResolve: false,
  autoResolveTime: 0,
  //endConversationButtonEnabled: false,
  transferToAgentButtonEnabled: false,
  botAutoReassignmentTime: 0,
  botAutoReassignment: false,
  sharedScheduleId: null,
  enableVideoChat: false,
  routingTiers: [],
  userTierAssignments: [],
  defaultVisitorLanguage: null
};
